import {
  Button,
  Grid,
  InputAdornment,
  Menu,
  MenuItem,
  TextField,
  Typography,
} from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import PersonAddOutlinedIcon from "@mui/icons-material/PersonAddOutlined";
import DescriptionOutlinedIcon from "@mui/icons-material/DescriptionOutlined";
import { useSuperAdminSingleOrg } from "../../../../context/SuperAdmin/SingleOrgContext";
import { useState } from "react";
import { FormDialog } from "../../../Form/Modal/FormDialog";
import { useAuthContext } from "../../../../hooks/Auth";

const HeadersUsersTable = () => {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);
  const { userSearchQuery, toggleCreateUserModal, setUserSearchQuery } =
    useSuperAdminSingleOrg();
  const { canAccess } = useAuthContext();

  const [isViewFormModal, setIsViewFormModal] = useState(false);
  const canCreateUser = canAccess("create:users");
  return (
    <>
      {isViewFormModal && (
        <FormDialog
          open={isViewFormModal}
          handleCloseModal={() => setIsViewFormModal(false)}
        />
      )}
      <Grid container spacing={4} display={"flex"} alignItems={"center"}>
        {/* Formulario de búsqueda */}
        <Grid item xs={6} md={6}>
          <TextField
            size="small"
            variant="outlined"
            placeholder="Ej: John Doe"
            value={userSearchQuery}
            onChange={(e) => setUserSearchQuery(e.target.value)}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <SearchIcon />
                </InputAdornment>
              ),
            }}
          />
        </Grid>
        {canCreateUser && (
          <Grid
            item
            xs={6}
            md={6}
            display={"flex"}
            alignItems={"center"}
            justifyContent={"flex-end"}
          >
            <Button
              variant="contained"
              onClick={() => toggleCreateUserModal(true)}
              sx={{ background: "#336B87" }}
              startIcon={<PersonAddOutlinedIcon />}
            >
              Crear usuario
            </Button>
            <Button
              onClick={(event: React.MouseEvent<HTMLButtonElement>) =>
                setAnchorEl(event.currentTarget)
              }
            >
              <Typography variant={"h4"} fontWeight={"bold"}>
                ...
              </Typography>
            </Button>
            <Menu
              id="basic-menu"
              anchorEl={anchorEl}
              open={open}
              onClose={() => setAnchorEl(null)}
              MenuListProps={{
                "aria-labelledby": "basic-button",
              }}
            >
              <MenuItem onClick={() => setIsViewFormModal(true)}>
                <DescriptionOutlinedIcon />
                Subir .csv
              </MenuItem>
            </Menu>
          </Grid>
        )}
      </Grid>
    </>
  );
};

export default HeadersUsersTable;
